__webpack_require__.p = "https://media-assets.swiggy.com/checkout-web-app-staging/";